/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentoDefaultDTO
 */
export interface DocumentoDefaultDTO {
    /**
     * 
     * @type {number}
     * @memberof DocumentoDefaultDTO
     */
    idAnagrafeMittente?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoDefaultDTO
     */
    idAnagrafeDestinatario?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoDefaultDTO
     */
    dataOperazione?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentoDefaultDTO
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentoDefaultDTO
     */
    tipo?: string | null;
}

/**
 * Check if a given object implements the DocumentoDefaultDTO interface.
 */
export function instanceOfDocumentoDefaultDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentoDefaultDTOFromJSON(json: any): DocumentoDefaultDTO {
    return DocumentoDefaultDTOFromJSONTyped(json, false);
}

export function DocumentoDefaultDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentoDefaultDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idAnagrafeMittente': !exists(json, 'idAnagrafeMittente') ? undefined : json['idAnagrafeMittente'],
        'idAnagrafeDestinatario': !exists(json, 'idAnagrafeDestinatario') ? undefined : json['idAnagrafeDestinatario'],
        'dataOperazione': !exists(json, 'dataOperazione') ? undefined : (json['dataOperazione'] === null ? null : new Date(json['dataOperazione'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'tipo': !exists(json, 'tipo') ? undefined : json['tipo'],
    };
}

export function DocumentoDefaultDTOToJSON(value?: DocumentoDefaultDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idAnagrafeMittente': value.idAnagrafeMittente,
        'idAnagrafeDestinatario': value.idAnagrafeDestinatario,
        'dataOperazione': value.dataOperazione === undefined ? undefined : (value.dataOperazione === null ? null : value.dataOperazione.toISOString()),
        'note': value.note,
        'tipo': value.tipo,
    };
}

